const COLOR_MAP = {
  cash: {
    headerBar: '#827717',
    sideBar: '#827717',
    searchBar: '#E65100',
    searchBarBtn: '#828707',
    dialogHeader: '#00C853',
    tableHeader: '#00C853',
    menuHover: '#f4f4f4',
    color7: '#00BFA5',
    checkOutHeader: '#2D6CBC',
    checkOutFooter: '#224C7E',
  },
}

export const changeTheme = (site = 'admin') => {
  const themeList = Object.keys(COLOR_MAP[site])
  themeList.forEach((v) => {
    document.body.style.setProperty(`--${v}`, COLOR_MAP[site][v])
  })
}
